import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Validators, FormControl } from "@angular/forms";
import { CommonFunctionService ,UserPOSData} from "../../../../services/Common/common-function.service";
import { TenderTipTaxService} from '../../../../POS/POSServices/Setup/tender-tip-tax.service';
@Component({
  selector: 'app-tips-view',
  templateUrl: './tips-view.component.html',
  styleUrls: ['./tips-view.component.scss']
})
export class TipsViewComponent implements OnInit {
  editable:boolean=false;
  merchantdata: UserPOSData ;
rows;
  constructor(
    private router: Router,
    private commonfunction: CommonFunctionService,
    private service: TenderTipTaxService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
     this.merchantdata = this.commonfunction.getUserPOSData();
    this.getGetEmployeeDetails();
  }
  getGetEmployeeDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetTipsDetail(form).subscribe(result => {   
      console.log("result.Id---" + result);
      if (result.id > 0) {
 this.rows=result;
      }
    });
  }
}
